import React from 'react';
import { useTranslation } from 'react-i18next';
import './NewGuideStyled.scss';
import UnderConstruction from '../../component/ui/Common/UnderConstruction';

const GwReportGuide = () => {
  const { t } = useTranslation();

  return (
    <div className="new-guide-page">
      <div className="page-title p-16">GWRPT</div>
      
      {/* 실제 페이지 콘텐츠 - 배경으로 보임 */}
      <div className="new-guide-content">
        <h2>{t('guide.rpt.heading')}</h2>
        <p>{t('guide.rpt.desc')}</p>
        
        {/* 더미 콘텐츠 */}
        <div className="new-stats-container">
          <div className="new-stat-card">
            <h3>{t('guide.rpt.cardGeneration')}</h3>
            <div className="new-stat-value">- / -</div>
          </div>
          <div className="new-stat-card">
            <h3>{t('guide.rpt.cardTemplate')}</h3>
            <div className="new-stat-value">{t('common.pending')}</div>
          </div>
          <div className="new-stat-card">
            <h3>{t('guide.rpt.cardAvailable')}</h3>
            <div className="new-stat-value">0</div>
          </div>
        </div>
      </div>
      
      {/* 공사중 표시 오버레이 */}
      <UnderConstruction />
    </div>
  );
};

export default GwReportGuide;
